/* esm.sh - screenfull@6.0.2 */
export * from "/*screenfull@6.0.2/esnext/screenfull.mjs";
export { default } from "/*screenfull@6.0.2/esnext/screenfull.mjs";
